import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  ShoppingCart, 
  Package, 
  Users, 
  BarChart3,
  Settings
} from 'lucide-react';
import { cn } from '@/lib/utils';

interface TabItem {
  id: string;
  label: string;
  icon: React.ComponentType<any>;
  path: string;
  badge?: number;
}

const MOBILE_TABS: TabItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/admin'
  },
  {
    id: 'sales',
    label: 'Ventas',
    icon: ShoppingCart,
    path: '/sales'
  },
  {
    id: 'inventory',
    label: 'Productos',
    icon: Package,
    path: '/inventory/products'
  },
  {
    id: 'customers',
    label: 'Clientes',
    icon: Users,
    path: '/customers'
  },
  {
    id: 'reports',
    label: 'Reportes',
    icon: BarChart3,
    path: '/reports'
  }
];

export function MobileTabBar() {
  const location = useLocation();
  
  // Solo mostrar en móvil
  const isMobile = window.innerWidth < 768;
  if (!isMobile) return null;

  return (
    <>
      {/* Espaciador para evitar que el contenido se superponga */}
      <div className="h-20 md:hidden" />
      
      {/* Tab Bar fijo en la parte inferior */}
      <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-background/95 backdrop-blur-md border-t border-border safe-area-bottom">
        <div className="flex items-center justify-around px-2 py-2">
          {MOBILE_TABS.map((tab) => {
            const isActive = location.pathname === tab.path || 
                           (tab.path !== '/admin' && location.pathname.startsWith(tab.path));
            
            return (
              <NavLink
                key={tab.id}
                to={tab.path}
                className={cn(
                  "flex flex-col items-center justify-center min-w-[60px] py-2 px-3 rounded-lg transition-all duration-200",
                  "apple-transition",
                  isActive 
                    ? "text-primary bg-primary/10" 
                    : "text-muted-foreground hover:text-foreground hover:bg-muted/50"
                )}
              >
                <div className="relative">
                  <tab.icon 
                    className={cn(
                      "h-5 w-5 mb-1 transition-transform duration-200",
                      isActive && "scale-110"
                    )} 
                  />
                  {tab.badge && (
                    <span className="absolute -top-1 -right-1 h-4 w-4 bg-destructive text-destructive-foreground text-xs rounded-full flex items-center justify-center">
                      {tab.badge > 9 ? '9+' : tab.badge}
                    </span>
                  )}
                </div>
                <span className={cn(
                  "text-xs font-medium transition-all duration-200",
                  isActive ? "scale-105" : "scale-100"
                )}>
                  {tab.label}
                </span>
              </NavLink>
            );
          })}
        </div>
      </nav>
    </>
  );
}